// @flow
import { get } from 'lodash';
import { getTimestamp } from 'Utils/date/dateUtils';
import { QUERY_DATE_FORMAT, QUERY_DEPARTURE_DATE } from 'Utils/uri/constants';

import { TRIP_INFORMATION_SET_DEPARTURE_DATE, SYNC_WITH_LOCATION } from 'Store/constants';

type State = timestamp;

const initialState = null;

function departureDateReducer(state: ?State = initialState, { type, payload }: Action<*>): ?State {
  switch (type) {
    case SYNC_WITH_LOCATION:
      // in cases where params is not in the url, we should just keep the state as it is.
      return payload.location.queryParams[QUERY_DEPARTURE_DATE]
        ? getTimestamp(payload.location.queryParams[QUERY_DEPARTURE_DATE], QUERY_DATE_FORMAT)
        : state;
    case TRIP_INFORMATION_SET_DEPARTURE_DATE:
      return get(payload, 'departureDate');
    default:
      return state;
  }
}

export default departureDateReducer;
